import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex } from '../../../../units/Box/Box';
import Text from '../../../../units/Text/Text';
import Button from '../../../../units/Button/Button';
import Icon from '../../../../units/Icon/Icon';

import FormInput from '../../FormControls/FormInput/FormInput';
import { FormTitle } from '../../FormUnits/FormUnits';

import withForm from '../../../../hocs/withForm';

import FormatUtils from '../../../../../utils/formatUtils';

const FormDescription = styled(Box)`
  text-align: center;
  line-height: 22px;
`;

const SmsLiveBox = styled(Box)`
  text-align: center;
`;

const FormActions = {
  sign: {
    actionId: 'sign'
  },
  regenarate: {
    actionId: 'regenerateButton'
  }
};

class SignSmsForm extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    getActionProps: PropTypes.func.isRequired,
    applyAction: PropTypes.func.isRequired,
    getFieldProps: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired
  };

  constructor() {
    super();

    this.smsTimer = null;
  }

  state = {
    smsLiveTime: null
  };

  componentDidMount() {
    this.startSmsTimer(this.props.params.timeToLive);
  }

  componentWillReceiveProps(nextProps) {
    this.handleSmsTimer(nextProps);
  }

  componentWillUnmount() {
    this.stopSmsTimer();
  }

  handleSmsTimer = nextProps => {
    if (
      this.props.actions.regenerateButton &&
      this.props.actions.regenerateButton.disabled &&
      !nextProps.actions.regenerateButton.disabled
    ) {
      this.stopSmsTimer();
    }
  };

  startSmsTimer = liveTime => {
    const smsLiveTime = liveTime || this.props.params.timeToLive;

    if (!smsLiveTime) return;
    this.stopSmsTimer();

    this.setState({
      smsLiveTime
    });

    this.smsTimer = setInterval(() => {
      if (this.state.smsLiveTime === 1) {
        this.stopSmsTimer();
      } else {
        this.setState(prevState => ({
          smsLiveTime: prevState.smsLiveTime - 1
        }));
      }
    }, 1000);
  };

  stopSmsTimer = () => {
    clearInterval(this.smsTimer);
    this.setState({
      smsLiveTime: null
    });
  };

  signSms = async values => {
    await this.props.applyAction({
      actionId: 'sign',
      values
    });
  };

  regenerateSms = () => {
    this.props.applyAction({
      actionId: 'regenerateButton'
    });
    this.startSmsTimer();
  };

  renderSmsLiveTimeMessage = () => {
    if (!this.state.smsLiveTime) return null;
    return (
      <SmsLiveBox className="form-sms__repeat-time" w="395px" mt="18px">
        <Text size="13px" font="caption">
          Запросить код повторно можно через
          {` ${FormatUtils.parseSeconds(this.state.smsLiveTime)}`}
        </Text>
      </SmsLiveBox>
    );
  };

  renderRequestSmsButton = () => {
    const { getActionProps } = this.props;

    const smsLiveTimeButtonProps = getActionProps(FormActions.regenarate);
    const visible = !this.state.smsLiveTime && smsLiveTimeButtonProps.visible;

    if (!visible) return null;
    return (
      <Box mt="12px">
        <Button
          type="text"
          size="small"
          onClick={this.regenerateSms}
          {...smsLiveTimeButtonProps}
        >
          <Flex align="center">
            <Icon icon="repeat" mr="5px" />
            <Text font="caption">Получить код повторно </Text>
          </Flex>
        </Button>
      </Box>
    );
  };

  renderSignSms = () => {
    const { getActionProps, getFieldProps, params, handleSubmit } = this.props;

    const singProps = getActionProps(FormActions.sign);

    return (
      <Flex justify="center" className="zeroClient_step_smsConfirm">
        <Flex width="700px" align="center" column>
          <FormTitle className="form-title_user-sms-confirm">
            Укажите полученный СМС-код
          </FormTitle>

          <FormDescription className="form-sms__description" mt="10px">
            <Box>
              <Text className="form-sms__description-phone">
                На ваш номер
                {` ${FormatUtils.getMaskedValue(params.phoneNumber, 'phone')} `}
                отправлено СМС с кодом.
              </Text>
            </Box>

            <Box>
              <Text> Введите полученный код:</Text>
            </Box>
          </FormDescription>

          <Box m="25px 0 0">
            <FormInput
              name="password"
              width="300px"
              height="50px"
              letterSpacing="7px"
              fontSize="22px"
              autoFocus
              {...getFieldProps('password')}
            />
          </Box>

          {this.renderSmsLiveTimeMessage()}
          {this.renderRequestSmsButton()}

          <Flex mt="30px">
            <Button
              className="btn-sign"
              onClick={handleSubmit(this.signSms)}
              width="185px"
              size="large"
              font="caption"
              {...singProps}
              disabled={singProps.disabled || singProps.isProcessing}
            >
              Подтвердить
            </Button>
          </Flex>
        </Flex>
      </Flex>
    );
  };

  render() {
    return this.renderSignSms();
  }
}

export default withForm(SignSmsForm);



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/SmsSign/SmsSign.js